export default __webpack_public_path__ + "static/media/paystack.5577e2b0.png";